export default __webpack_public_path__ + "static/media/ic_access.893210cc.svg";